import React from 'react';
import { saveAs } from 'file-saver';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

const SaveCalculation = ({ inputData }) => {
  const handleSaveCalculation = () => {
    const calculationData = inputData;
    const calculationDataJSON = JSON.stringify(calculationData);

    const blob = new Blob([calculationDataJSON], { type: 'application/json' });

    // Ask the user for the desired file name
    const fileName = prompt('Enter the file name:', 'calculation.json');

    // Check if the user provided a file name
    if (fileName) {
      // Use FileSaver.js to save the file with the specified name
      saveAs(blob, fileName);
    }
  };


    const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSaveCalculation}
        // Only render the startIcon on non-mobile views
        startIcon={!isMobile ? <SaveIcon /> : null}
        sx={{
          borderRadius: "12px",
          fontFamily: "'Hubballi', sans-serif",
          fontSize: "1.1rem",
          textTransform: "none",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          // Adjust styles for mobile (icon-only button)
          ...(isMobile && {
            minWidth: 'auto',
            padding: '0.6rem', // Square padding
          }),
          // Original padding for desktop
          ...(!isMobile && {
            padding: "0.3rem 1.2rem",
          }),
        }}
      >
        {/* Render only the icon on mobile, otherwise render the text */}
        {isMobile ? <SaveIcon /> : "Save Calculation"}
      </Button>
    </div>
  );
};

export default SaveCalculation;
